import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(theme => ({
  card: {
    marginBottom: 20,
    borderRadius: 18,
    backgroundColor: theme.colors.dark.midnightBlue,
  },
  cardTop: {
    display: 'flex',
    flexDirection: 'column',
    padding: '24px 24px 16px',
    position: 'relative',
  },
  cardUpper: {
    display: 'flex',
    marginBottom: 16,
  },
  cardImg: {
    width: 60,
    height: 60,
    borderRadius: 10,
  },
  cardInfo: {
    paddingLeft: 20,
  },
  cardTitle: {
    marginBottom: 8,
    fontWeight: 700,
    fontSize: theme.fonts.sizes.font18PX,
    color: theme.colors.light.lightCyan,
  },
  cardPrice: {
    fontWeight: 500,
    color: theme.colors.light.lightCyan,
    fontSize: theme.fonts.sizes.font14PX,
  },
  shortDescription: {
    fontSize: theme.fonts.sizes.font14PX,
    color: theme.colors.light.lightSteelBlue,
  },
  collapseInner: {
    margin: '0 20px 20px',
  },
  descriptionWrapper: {
    marginBottom: 20,
  },
  heading: {
    marginBottom: 10,
    fontWeight: 700,
    fontSize: theme.fonts.sizes.font16PX,
    color: theme.colors.light.lightSteelBlue,
  },
  longDescription: {
    marginBottom: 20,
    color: theme.colors.light.lightCyan,
    fontSize: theme.fonts.sizes.font12PX,
  },
  divider: {
    width: '100%',
    height: 1,
    marginBottom: 20,
    backgroundColor: theme.colors.dark.steelBlue,
  },
  allergenText: {
    fontSize: theme.fonts.sizes.font12PX,
    color: theme.colors.light.lightCyan,
  },
  desriptionNotAvailable: {
    marginBottom: 10,
    fontSize: theme.fonts.sizes.font14PX,
    color: theme.colors.light.lightSteelBlue,
  },
  allergenNotAvailable: {
    fontSize: theme.fonts.sizes.font14PX,
    color: theme.colors.light.lightSteelBlue,
  },
  cardBottom: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '12px 24px',
    borderRadius: '0 0 10px 10px',
    backgroundColor: theme.colors.dark.darkSlateBlue,
  },
  moreInfoButton: {
    display: 'flex',
    alignItems: 'center',
    padding: 0,
    border: 0,
    backgroundColor: 'transparent',
  },
  moreInfoButtonText: {
    maxWidth: 60,
    marginRight: 8,
    fontSize: 13,
    fontWeight: 600,
    color: theme.colors.light.lightCyan,
  },
}));

export const useStylesButton = makeStyles(theme => ({
  root: {
    width: 36,
    minWidth: 36,
    height: 36,
    backgroundColor: theme.colors.dark.steelBlue,
    color: theme.colors.light.freshPowder,
    fontSize: theme.fonts.sizes.font20PX,
    '&:hover': {
      backgroundColor: theme.colors.dark.steelBlue,
      color: theme.colors.light.freshPowder,
    },
  },
}));
